<template>
  <div>
    <Swiper
      class="swiper--si-gallery"
      :modules="[SwiperAutoplay]"
      :allowTouchMove="false"
      :slides-per-view="4"
      :spaceBetween="20"
      :loop="true"
      :speed="5000"
      :autoplay="{
        delay: 0,
        reverseDirection: false,
        disableOnInteraction: false,
      }"
      :breakpoints="{
        920: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        350: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      }"
    >
      <SwiperSlide
        class="swiper-slide--custom"
        v-for="(post, i) in posts"
        :key="i"
        @click="() => showImgTop(i)"
      >
        <img :src="post.image" />
      </SwiperSlide>
    </Swiper>
    <VueEasyLightbox
      :visible="visibleRefTop"
      :imgs="posts.map((item) => item.image)"
      :index="indexRefTop"
      @hide="onHideTop"
    />
  </div>
  <div class="mt-4" v-if="posts.length">
    <Swiper
      class="swiper--si-gallery"
      :modules="[SwiperAutoplay]"
      :allowTouchMove="false"
      :slides-per-view="4"
      :spaceBetween="20"
      :loop="true"
      :speed="5000"
      :autoplay="{
        delay: 0,
        reverseDirection: true,
        disableOnInteraction: false,
      }"
      :breakpoints="{
        920: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        350: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      }"
    >
      <SwiperSlide
        class="swiper-slide--custom"
        v-for="(post, i) in posts"
        :key="i"
        @click="() => showImg(i)"
      >
        <img :src="post.image" />
      </SwiperSlide>
    </Swiper>
    <VueEasyLightbox
      :visible="visibleRef"
      :imgs="posts.map((item) => item.image)"
      :index="indexRef"
      @hide="onHide"
    />
  </div>
</template>

<script setup>
import VueEasyLightbox from 'vue-easy-lightbox'
const { posts } = defineProps(["posts"]);

const visibleRefTop = ref(false);
const indexRefTop = ref(0);

const showImgTop = (i) => {
  indexRefTop.value = i;
  visibleRefTop.value = true;
};

const onHideTop = () => (visibleRefTop.value = false);

const visibleRef = ref(false);
const indexRef = ref(0);

const showImg = (i) => {
  indexRef.value = i;
  visibleRef.value = true;
};

const onHide = () => (visibleRef.value = false);

</script>

